import { render } from "./HeaderMainPage.vue?vue&type=template&id=7ace5542"
import script from "./HeaderMainPage.vue?vue&type=script&lang=js"
export * from "./HeaderMainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__